const pluralRules = {
    ru: (count) => {
        const min = 2;
        const max = 4;
        let result = 'many';
        if (count >= min && count <= max)
            result = 'some';
        if (count === 1)
            result = 'one';
        return result;
    },
};
const defaultRule = (count) => (count === 1 ? 'one' : 'many');
export default function getPluralRule(language) {
    return pluralRules[language] || defaultRule;
}
